export const MOBILE_COLUMNS = 4;
export const MOBILE_COLUMN_SIZE = '68px';
export const MOBILE_COLUMN_GAP = '16px';

export const TABLET_COLUMNS = 8;
export const TABLET_COLUMN_SIZE = '59px';
export const TABLET_COLUMN_GAP = '24px';

export const DESKTOP_COLUMNS = 16;
export const DESKTOP_COLUMN_SIZE = 61.5;
export const DESKTOP_COLUMN_GAP = 24;

export const CONTAINER_MOBILE = '100%';
export const CONTAINER_TABLET = '768px';
export const CONTAINER_DESKTOP = '1440px';

export const GRID_GUTTER_WIDTH = 10;

export const DEFAULT_FONT_FAMILY = 'Interstate, sans-serif';
